import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, videos, features, faqs } from '@/mocks/data';

function formatViews(n: number): string {
  if (n >= 10000000) return `${(n / 10000000).toFixed(1)}千万`;
  if (n >= 10000) return `${(n / 10000).toFixed(0)}万`;
  return n.toString();
}

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function Home() {
  const hotVideos = [...videos].sort((a, b) => b.views - a.views).slice(0, 8);
  const latestVideos = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 8);

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20green%20gradient%20background%20with%20soft%20bokeh%20light%20effect%20cinematic%20atmosphere%20modern%20entertainment%20streaming%20vibe%20dark%20ambient%20with%20warm%20glowing%20accents%20subtle%20fruity%20shapes%20creative%20design&width=1600&height=900&seq=hero-bala-video&orientation=landscape"
          alt="芭乐视频 - 水果视频平台"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
        <div className="relative z-10 w-full text-center px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
            水果视频平台
            <br />
            <span className="text-primary-300">高清全集 · 不缓冲</span>
          </h1>
          <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            芭乐视频为您聚合蜜桃视频、西瓜视频、樱桃视频等热门水果视频平台资源，
            <br className="hidden sm:block" />
            电视剧、电影、动漫、综艺、纪录片、短剧——全部免费在线观看，每日更新。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianshiju"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-full font-label text-sm whitespace-nowrap cursor-pointer no-underline hover:bg-primary-600 transition-all duration-200 hover:scale-105 active:scale-95"
            >
              立即观看
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-white/10 text-white border border-white/30 rounded-full font-label text-sm whitespace-nowrap cursor-pointer no-underline hover:bg-white/20 transition-all duration-200"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            六大视频分类，满足您的各种观影需求。点击分类浏览更多精彩内容。
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const count = videos.filter((v) => v.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer no-underline hover:bg-primary-50/50"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="font-label text-sm md:text-base text-foreground-800 group-hover:text-primary-600 whitespace-nowrap font-medium">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">{count}部资源</span>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="bg-background-100/70 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500">播放量最高的精选视频</p>
            </div>
            <Link
              to="/category/dianying"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer no-underline whitespace-nowrap font-medium"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {hotVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline hover:translate-y-[-2px]"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={video.coverImage}
                    alt={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    title={`${video.title} - 芭乐视频`}
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-label">
                      {getCategoryName(video.category)}
                    </span>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/60 text-white text-xs px-2 py-0.5 rounded-md">
                    {formatViews(video.views)}次播放
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-label text-sm md:text-base text-foreground-900 font-medium line-clamp-1 mb-1">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2 leading-relaxed">
                    {video.description}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-accent-600 flex items-center gap-0.5">
                      <i className="ri-star-fill text-xs"></i> {video.rating}
                    </span>
                    <span className="text-xs text-foreground-400">{video.platform}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新最新剧集和电影</p>
          </div>
          <Link
            to="/category/duanju"
            className="flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 cursor-pointer no-underline whitespace-nowrap font-medium"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex gap-3 bg-background-50 rounded-xl p-3 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer no-underline hover:translate-x-1"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={video.thumbImage}
                  alt={video.title}
                  className="w-full h-full object-cover object-top"
                  title={`${video.title} - 芭乐视频`}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-label text-sm text-foreground-900 font-medium line-clamp-1 mb-1">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                  {video.description}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded text-xs">
                    {getCategoryName(video.category)}
                  </span>
                  <span>{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-background-100/70 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              为什么选择芭乐视频？
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              六大核心优势，为您打造极致的观影体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className={`${feat.icon} text-lg md:text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-label text-sm md:text-base text-foreground-900 font-medium mb-1">
                    {feat.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            关于芭乐视频，您可能想了解的问题
          </p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <h3 className="font-label text-sm text-foreground-900 font-medium mb-2">
                {faq.question}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </section>

      <Footer />
    </main>
  );
}